import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import { ProjectMethodologyEnum } from 'gql/graphql';
import { bimWorkOrderConstructionTypesGql } from 'pages/Project/BimProject/WorkOrder/BimWorkOrderOthersPrice/bimWorkOrderOthersQueries';

import { useEffect, useMemo } from 'react';

interface IUseConstructionTypes {
    orderId: string | undefined;
    methodology: ProjectMethodologyEnum;
}

export const useConstructionTypes = ({ orderId, methodology }: IUseConstructionTypes) => {
    const [resetBimWorkOrderConstructionTypes] = useResetStoreData({
        requestId: 'bimWorkOrderConstructionTypes',
    });

    useEffect(
        () => () => {
            resetBimWorkOrderConstructionTypes(undefined);
        },
        [resetBimWorkOrderConstructionTypes],
    );

    const variables = useMemo(
        () => ({
            workOrderId: Number(orderId),
        }),
        [orderId],
    );

    const [bimWorkOrderConstructionTypesData, bimWorkOrderConstructionTypesStatus] = useRequest({
        requestId: 'bimWorkOrderConstructionTypes',
        query: bimWorkOrderConstructionTypesGql,
        variables,
        withEffect: !!(orderId && methodology === ProjectMethodologyEnum.Bim),
    });

    return useMemo(
        () => ({
            constructionTypesData: bimWorkOrderConstructionTypesData?.bimWorkOrderConstructionTypes?.data ?? [],
            constructionTypesStatus: bimWorkOrderConstructionTypesStatus,
        }),
        [bimWorkOrderConstructionTypesData?.bimWorkOrderConstructionTypes?.data, bimWorkOrderConstructionTypesStatus],
    );
};
